
import React from "react";
import { useState, useEffect } from 'react';

import dayjs from 'dayjs';



//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getShoppingStep } from "../../store/selectors.js"; //global state : shopping state
import { shoppingStepSlice } from "../../store/shoppingStepSlice.js";
import { spotsListSlice } from "../../store/spotsListSlice.js";

import Button from '@mui/material/Button';

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//import created compnenets
import StepOne from '../step1/layout/stepone/StepOne' //component for step 1 : location picker, dates and times picker
import StepTwo from '../step2/layout/steptwo/StepTwo' //component for step 2 : Shopping Gallery + reminder
import StepThree from '../step3/layout/stepthree/StepThree' //component for step 2 : Shopping Gallery + reminder
import StepFour from '../step4/layout/stepfour/StepFour' //component for step 2 : Shopping Gallery + reminder
import StepFive from '../step5/layout/stepfive/StepFive' //component for step 2 : Shopping Gallery + reminder
import StepSix from '../step6/layout/stepsix/StepSix' //component for step 2 : Shopping Gallery + reminder
import BannerMoutchicLoisirs from '../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs'

import logoMl2 from '../../../src/images/logo-moutchic-loisirs-text-500.png' //image logo
import logoKeb2 from '../../../src/images/logo_velo_keb_250.png' //image logo
import { date } from "yup";
import { Translate } from "@mui/icons-material";

//MUI
import LanguageIcon from '@mui/icons-material/Language';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//Translate utils :
import { translator } from "../../../src/utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
import { langSlice } from "../../store/langSlice.js";

//navigator is the main block, managing navigation step by step
function Navigator() {
    const dispatch = useDispatch();
    const step = useSelector(getShoppingStep) //global state : shopping step
    const lang = useSelector(getLang) //global state : language
    let listSpots = [];
    let [chargee, setChargee] = useState(false);

    useEffect(() => { //change opening hours when spot change (idspot as dependency)
        console.log(listSpots);
        setChargee(listSpots.length < 1);

    }, [listSpots])


    const prevStep = (event) => {
        dispatch(shoppingStepSlice.actions.previousShoppingStep());
    }
    const nextStep = (event) => {
        setBackup();
        dispatch(shoppingStepSlice.actions.nextShoppingStep());
    }


    axios.get(baseURL + "/spot").then((response) => {
        listSpots = [].concat(response.data);
        dispatch(spotsListSlice.actions.setSpotsList(listSpots));
    });


    function setBackup() {

        //// --- Check backup
        axios.get(baseURL + "/backup/1").then((response) => {
            let dateBackup = response.data.data.date_backup;
            let today = dayjs();
            let backupNeeded = today.isAfter(dateBackup, "day");
            console.log("backup à faire :", backupNeeded);

            if (backupNeeded === true) {
                // on déclenche l'envoie du mail avec la base sqlite
                axios.post(baseURL + "/mailing/mail-backup").then((response) => {

                    //on modifie la date du dernier backup
                    if (response.status === 200) {

                        axios.put(baseURL + "/backup/1",
                            {
                                date_backup: dayjs().format("YYYY-MM-DD")
                            }
                        ).then((response) => {
                            console.log(response.data)

                        })
                    }

                })

            }

        });
    }




    return (
        <main>
            {/* <div >
                <Button variant="contained" onClick={prevStep}>previous step</Button>
                <Button variant="contained" onClick={nextStep}>next step</Button>
            </div> */}

            {step > 0 ?
                <BannerMoutchicLoisirs title={translator("Réservez vos vélos en ligne", lang, "navigatorTitle")} />
                : null}

            {/* --------------
                display correct component, based on current shoppinng step :  
                --------------------------*/}
            {step === 0 ?

                <div className="accueil">

                    <div className="accueil-top">
                        <div className="accueil-top-logo">
                            <img src={logoMl2} alt="logo moutchic loisirs, location de cycles" />
                        </div>

                        <div className="accueil-top-lang">
                            <h1>{translator("Bienvenue sur notre plateforme de réservations en ligne!", lang, "homePage0")}</h1>
                            <div className="header-ml-right-select-lang">
                                <LanguageIcon />
                                <Select
                                    size="small"
                                    value={lang}
                                    onChange={e => dispatch(langSlice.actions.setLang(e.target.value))}
                                >
                                    <MenuItem value={"fr"}>FR</MenuItem>
                                    <MenuItem value={"gb"}>ENG</MenuItem>
                                </Select>

                            </div>
                        </div>
                    </div>
                    <div className="accueil-middle">
                        <h2>{translator("Vous voulez préparer vos vacances et votre séjour à Lacanau?", lang, "homePage1")}</h2>
                        <p>{translator("Laissez vous guider par notre plateforme, étape après étape, et débarquez au Moutchic, ou ailleurs, avec votre matériel déjà prêt :-)", lang, "homePage2")}</p>

                        <div className="accueil-bottom">
                            <Button
                                className="accueil-bottom-bouton-next"
                                variant="contained"
                                onClick={nextStep}
                                disabled={chargee === false}>
                                {translator("Réservez vos vélos en ligne", lang, "navigatorTitle")}</Button>
                        </div>
                        <img className="accueil-middle-photo" src="https://manuelvivion.net/nestor/bikes/images/gallerie_photo_velos_lacanau.jpg" alt="location de vélos au lac de lacanau" />

                        <ul>
                            <li>{translator("Choisissez votre point de location parmi nos différents spots.", lang, "homePageList1")}</li>
                            <li>{translator("Vous pouvez aussi faire une demande de livraison, dans un des secteurs proposés (3 jours mini.)", lang, "homePageList2")}</li>
                            <li>{translator("Choisissez vos dates, vos horaires.", lang, "homePageList3")}</li>
                            <li>{translator("Un prix dégressif est automatiquement calculé selon votre durée de location", lang, "homePageList4")}</li>
                            <li>{translator("Ajoutez vos articles dans votre panier.", lang, "homePageList5")}</li>
                            <li>{translator("Pour un accueil sur mesures, pensez à renseigner vos tailles et prénoms pour que l'on vous prépare les bons vélos.", lang, "homePageList6")}</li>
                            <li>{translator("Laissez nous un petit commentaire si besoin.", lang, "homePageList7")}</li>
                            <li>{translator("Vous pourrez à tout moment revenir et modifier vos choix avant de valider et régler votre réservation.", lang, "homePageList8")}</li>
                            <li>{translator("A très bientôt.", lang, "homePageList9")}</li>


                        </ul>
                    </div>

                </div>

                : null}
            {step === 1 ? <StepOne /> : null}
            {step === 2 ? <StepTwo /> : null}
            {step === 3 ? <StepThree /> : null}
            {step === 4 ? <StepFour /> : null}
            {step === 5 ? <StepFive /> : null}
            {step === 6 ? <StepSix /> : null}

        </main>

    )
}




export default Navigator